import React from "react";
import { BoutonParametres } from "../components/Parametres";
import { Pastille, useCompteurs, useNotificationsDeLaRubrique } from "../services/compteurs";

const sections = [
  ["dashboard", "Dashboard"],
  ["exams", "Mes épreuves"],
  ["drafts", "Brouillons"],
  ["history", "Historique"],
  ["hors-connexion", "Hors connexion"],
  ["wallet", "Portefeuille"],
  ["messages", "Messagerie"],
  ["establishments", "Établissements"],
  ["td", "Fiches TD"],
  ["soutien", "Profil soutien"],
  ["notifications", "Notifications"],
  ["account", "Compte"],
];

export default function TeacherNavigation({ activeView, onNavigate, onLogout }) {
  const compteurs = useCompteurs(activeView);
  useNotificationsDeLaRubrique(activeView === "messages" ? ["messages"] : null, compteurs.notifications);
  return (
    <header className="ql-teacher-header">
      <div className="ql-teacher-brand">
        <img src="/static/logo.png" alt="Quick Learning" />
        <div>
          <strong>Quick Learning</strong>
          <span>Espace enseignant</span>
        </div>
      </div>
      <nav aria-label="Actions de l’espace enseignant">
        {sections.map(([view, label]) => (
          <button
            type="button"
            className={`ql-teacher-link${activeView === view ? " active" : ""}`}
            key={view}
            onClick={() => onNavigate(view)}
          >
            {label}
            {(view === "messages" || view === "notifications") && <Pastille nombre={compteurs[view]} />}
          </button>
        ))}
        <BoutonParametres className="ql-teacher-link" avecTexte />
        <button type="button" className="ql-teacher-logout" onClick={onLogout}>
          Déconnexion
        </button>
      </nav>
    </header>
  );
}
